<template>
  <div id="dailyNewsletter">
    <div class="content_box">
      <div class="inner">
        <div class="contact_title">
          <h2>Daily Newsletter</h2>
          <p></p>
        </div>
        <div class="main_content">
          <div v-if="showIframe === true">
            <iframe
              src="https://newsletters.tradingcentral.com/vtmarkets/signup_widgets_live.aspx"
              frameborder="0"
              scrolling="no"
              width="100%"
              height="735"
            ></iframe>
          </div>
          <div v-if="showIframe === false" class="meta_box">
            <div class="top_box">
              <div class="subtitle">Empowering your investment by getting up-to-date market insights everyday.</div>
              <div class="box_wrapper">
                <div class="image_box">
                  <img src="@/assets/images/promotions/shutterstock.png" alt="shutterstock" />
                </div>
                <div>
                  <div class="info_box">
                    <div class="info_title">Market wrap</div>
                    <div class="info_content">
                      Get the news coverage on market trending products including currencies, commodities, stocks and
                      more from top-tier analyst teams.
                    </div>
                  </div>
                  <div class="info_box">
                    <div class="info_title">What to expect today</div>
                    <div class="info_content">Get insights on hot economical events within the day.</div>
                  </div>
                  <div class="info_box">
                    <div class="info_title">Market sentiment + Analyst views</div>
                    <div class="info_content">
                      Find out how the crowd feels about the instruments and their opinions to help you gain more trade
                      ideas. Directional views from the global research desks of Trading Central that supported by
                      reliable indicators.
                    </div>
                  </div>
                  <div class="info_box">
                    <div class="info_title">Economic Calendar</div>
                    <div class="info_content">
                      View all relevant economic events associated to the instrument to get you prepared for upcoming
                      market volatility.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom_box">
              <el-row type="flex" justify="center" align="middle">
                <el-col :xs="{ span: 24 }" :sm="{ span: 12 }" :lg="{ span: 6 }">
                  <div class="subtitle">How to access Daily Newsletter:</div>
                </el-col>
                <el-col :xs="{ span: 24 }" :sm="{ span: 11, offset: 1 }" :lg="{ span: 5, offset: 1 }">
                  <div>
                    <div class="img_wrapper"><img src="@/assets/images/promotions/deposit.png" alt="deposit" /></div>
                    <p>1. Ensure your account is funded with a minimum of $50</p>
                  </div>
                </el-col>
                <el-col :xs="{ span: 24 }" :sm="{ span: 11, offset: 1 }" :lg="{ span: 5, offset: 1 }">
                  <div>
                    <div class="img_wrapper">
                      <img src="@/assets/images/promotions/conditions.png" alt="conditions" />
                    </div>
                    <p>
                      2. Agree to the
                      <a :href="tncLink" target="_blank">terms and conditions.</a>
                    </p>
                  </div>
                </el-col>
                <el-col :xs="{ span: 24 }" :sm="{ span: 11, offset: 1 }" :lg="{ span: 5, offset: 1 }">
                  <div class="deposit_btn">
                    <a @click.stop.prevent="getDepositBlacklist()">Deposit Now</a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import blackList from '@/mixins/blackList';
import { apiDailyNewsletter } from '@/resource';
import { countryCodeEnum } from '@/constants/country';

export default {
  data() {
    return {
      showIframe: null
    };
  },
  computed: {
    countryCode() {
      return this.$store.state.common.countryCode;
    },
    tncLink() {
      return this.countryCode == countryCodeEnum.IRAN
        ? 'https://www.vtmarkets-fa.com/promotions/other-offers/daily-newsletter/?_gl=1*ybfsw2*_ga*MTk4NTQ4MTgzLjE3MDg5MTMyOTY.*_ga_GYCR7M6G5K*MTcwOTYyNTEyNi4xNC4xLjE3MDk2MjY2OTYuNTkuMC4w'
        : 'https://www.vtmarkets.com/promotions/other-offers/daily-newsletter';
    }
  },
  mounted() {
    apiDailyNewsletter()
      .then(resp => {
        if (resp.data.data) {
          this.showIframe = true;
        } else {
          this.showIframe = false;
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  mixins: [blackList]
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/dailyNewsletter.scss';
</style>
